import {v4 as uuid} from "uuid"

export const INVOICENO = () =>
  uuid().toUpperCase().replaceAll("-", "").slice(0, 18);